import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useNearbyEvents from "../../hooks/useNearbyEvents";
import "./NearbyEventToast.css";

const ENTRANCE_DELAY = 500;
const EXIT_DURATION = 300;

const NearbyEventToast = () => {
  const { nearbyEvent, dismiss } = useNearbyEvents();
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const delayTimer = useRef(null);

  // Entrance delay — avoids flash during rapid navigations
  useEffect(function delayToastEntrance() {
    if (nearbyEvent) {
      delayTimer.current = setTimeout(() => setVisible(true), ENTRANCE_DELAY);
    } else {
      setVisible(false);
      setExiting(false);
    }
    return () => clearTimeout(delayTimer.current);
  }, [nearbyEvent]);

  const handleDismiss = (eventId) => {
    setExiting(true);
    setTimeout(() => {
      dismiss(eventId);
      setVisible(false);
      setExiting(false);
    }, EXIT_DURATION);
  };

  if (!nearbyEvent || !visible) return null;

  return (
    <div
      className={`event-toast${exiting ? " event-toast--exiting" : ""}`}
      role="status"
    >
      <i className="fa-solid fa-calendar-day event-toast__icon" />
      <div className="event-toast__body">
        <span className="event-toast__label">Happening nearby</span>
        <Link
          className="event-toast__link"
          to={`/events/${nearbyEvent.slug}`}
          state={{ event: nearbyEvent }}
          onClick={() => handleDismiss(nearbyEvent._id)}
        >
          {nearbyEvent.name}
        </Link>
      </div>
      <button
        className="event-toast__dismiss"
        aria-label="Dismiss"
        onClick={() => handleDismiss(nearbyEvent._id)}
      >
        <i className="fa-solid fa-xmark" />
      </button>
    </div>
  );
};

export default NearbyEventToast;
